import namor from 'namor';

const range = len => {
  const arr = [];
  for (let i = 0; i < len; i += 1) {
    arr.push(i);
  }
  return arr;
};

const getFraction = max => Math.floor(Math.random() * max);

const newRow = (index = 0) => {
  const sent = Math.floor(Math.random() * 100);

  return {
    id: index,
    name: namor.generate({ words: 1, numbers: 0 }),
    sent,
    delivered: getFraction(sent),
    total_open: getFraction(sent),
    unique_click: getFraction(sent),
    unique_open: getFraction(sent),
    reply_count: getFraction(sent),
    clickthrough: getFraction(sent),
    unsubscription_count: getFraction(sent),
    spam_count: getFraction(sent),
    bounce_count: getFraction(sent),
    soft_bounce: getFraction(sent),
  };
};

export default function makeData(len = 5553) {
  return range(len).map((val, index) => {
    return {
      ...newRow(index),
    };
  });
}
